import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { BackgroundImage } from "../../images";
import { OutboundLink } from 'gatsby-plugin-google-gtag'

import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import PinterestIcon from '@mui/icons-material/Pinterest';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';

import ContactPhoneRoundedIcon from '@mui/icons-material/ContactPhoneRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';

import ReviewsWidget from "../ReviewsWidget";

import { Global } from "@emotion/react";
import { emotionGlobalCss } from "./styles";


export default function Footer() {
  const intl = useIntl();
  const t = intl.formatMessage;


  return (

    <>
      <Global styles={emotionGlobalCss} />
      <ReviewsWidget />

      <div className="cta">
        <div className="wrap">
          <div className="ctaContent">
            <div><FormattedMessage id="cta-text.title" /></div>
            <p><FormattedMessage id="cta-text.text" /></p>
            <OutboundLink href="http://andmar.cloud"><FormattedMessage id="footer-cta-button" /></OutboundLink>
          </div>
        </div>
      </div>


      <div className="cityContact">
        <div className="innerCityContact">
          <div className="wrap">
            <div className="wrapAbsolute">



              <div className="cityC">
                <div className="innerCityC">
                  <i className="contactIcon"><ContactPhoneRoundedIcon sx={{ width: "100%", height: "100%" }} /></i>
                  <h3><FormattedMessage id="contact-info.title" /></h3>
                  <p><FormattedMessage id="contact-info.telephone-tag" /><a style={{ textDecoration: 'none' }} href={"tel:" + t({ id: "contact-info.telephone-number" })}><FormattedMessage id="contact-info.telephone-number" /></a></p>
                  <p><FormattedMessage id="contact-info.tollfree-tag" /><a style={{ textDecoration: 'none' }} href={"tel:" + t({ id: "contact-info.tollfree-number" })}><FormattedMessage id="contact-info.tollfree-number" /></a></p>
                  <p><FormattedMessage id="contact-info.email-tag" /><a style={{ textDecoration: 'none' }} href={"mailto:" + t({ id: "contact-info.email" })}><FormattedMessage id="contact-info.email" /></a></p>



                </div>
              </div>

              <div className="cityC">
                <div className="innerCityC">
                  <i className="hoursIcon"><AccessTimeRoundedIcon sx={{ width: "100%", height: "100%" }} /></i>
                  <h3><FormattedMessage id="hours.title" /></h3>
                  <p><FormattedMessage id="hours.week-tag" /><FormattedMessage id="hours.week-hours" /></p>
                  <p><FormattedMessage id="hours.saturday-tag" /><FormattedMessage id="hours.saturday-hours" /></p>
                  <p><FormattedMessage id="hours.sunday-tag" /><FormattedMessage id="hours.sunday-hours" /></p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>


      <div className="widgetsBackground">
        <div className="footer-widgets" id="genesis-footer-widgets">
          <BackgroundImage className="backgroundImage" src="footerBackground" />
          {/* <h2 className="genesis-sidebar-title screen-reader-text">Footer</h2> */}
          <div className="wrap">



            <div className="widget-area footer-widgets-1 footer-widget-area">

              <section id="text-2" className="widget widget_text">
                <div className="widget-wrap">
                  <div className="textwidget">
                    <p> <FormattedMessage id="footer-text" /> </p>

                    <div className="socialMedia">
                      <OutboundLink href="https://www.facebook.com/andmarecoenergy" ><i><FacebookRoundedIcon sx={{ width: "80%", height: "100%" }} /></i></OutboundLink>
                      <OutboundLink href="https://www.instagram.com/andmarecoenergy/" ><i><InstagramIcon sx={{ width: "80%", height: "100%" }} /></i></OutboundLink>
                      <OutboundLink href="https://twitter.com/Andmarecoenergy" ><i><TwitterIcon sx={{ width: "80%", height: "100%" }} /></i></OutboundLink>
                      {/* <OutboundLink href="https://www.pinterest.ca/adominique0872/" ><i><PinterestIcon sx={{ width: "80%", height: "100%" }} /></i></OutboundLink> */}
                      <OutboundLink href="https://www.linkedin.com/company/andmar-eco-energy" ><i><LinkedInIcon sx={{ width: "80%", height: "100%" }} /></i></OutboundLink>
                      <OutboundLink href="https://www.youtube.com/channel/UCa1Rx6rH6P-ZIBy9bXkt9AQ" ><i><YouTubeIcon sx={{ width: "80%", height: "100%" }} /></i></OutboundLink>
                    </div>

                  </div>
                </div>
              </section>
            </div>

            {/* <div className="widget-area footer-widgets-2 footer-widget-area"></div> */}

          </div>
        </div>
      </div>




      <div className="site-footer" >
        <div className="wrap">

          <div className="left">
            <p><FormattedMessage id="footer-copyright" /></p>
          </div>



        </div>
      </div>
    </>
  )
}




